interface ProxyFlag {
  name: string;
  value: string;
}

export default function isBlacklisted(flags: ProxyFlag[]) {
  return flags.some((flag) => {
    return flag.name === 'zeroed' && flag.value === 'true';
  });
}
